import OrganizationSelect from "./OrganizationSelect";
import DaysSelect from "./DaysSelect";
import CampaignStatusSelect from "./CampaignStatusSelect";
import EngagementSelect from "./EngagementSelect";
import ObjectiveSelect from "./ObjectiveSelect";
import LaunchSelect from "./LaunchSelect";

export default function DashHeader() {
    return (
        <div className="dash-filters">
            <OrganizationSelect />
            <DaysSelect />
            <CampaignStatusSelect />
            <EngagementSelect />
            <ObjectiveSelect />
            <LaunchSelect />
        </div>
    );
}
